module.exports = __webpack_public_path__ + "static/media/translations.1033.e91c48cd.resx";